var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "inline-flex items-center cursor-pointer",
      attrs: {
        "aria-checked": _vm.checked ? "true" : "false",
        role: "checkbox",
        tabindex: "0"
      },
      on: { click: _vm.toggle }
    },
    [
      _c("span", {
        staticClass: "text-sm mr-1 w-16",
        class: {
          "text-gray-700 font-medium": _vm.checked,
          "text-gray-500": !_vm.checked
        },
        domProps: { textContent: _vm._s(_vm.checked ? "Enabled" : "Disabled") }
      }),
      _c("span", { staticClass: "relative w-12 h-6" }, [
        _c("span", {
          staticClass:
            "\n                absolute rounded-full w-10 h-4 mt-1 ml-1 top-0 left-0\n                border border-primary-300 text-primary-900\n                transition-colors duration-200\n            ",
          class: {
            "bg-primary-300": _vm.checked
          },
          attrs: { "aria-hidden": "true" }
        }),
        _c("span", {
          staticClass:
            "\n                absolute rounded-full w-6 h-6 left-0 top-1/2 -translate-y-1/2\n                bg-primary-800 transform transition-transform duration-200\n            ",
          class: {
            "translate-x-6": _vm.checked,
            "translate-x-0": !_vm.checked
          },
          attrs: { "aria-hidden": "true" }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }